import React from 'react';
import { FastField } from 'formik';
import FormikInput from '../FormikInput';
import FormikCheckbox from '../FormikCheckbox';
import { FilterData } from './BuzzlUserFilterDrawer';
import { buzzlRoles } from '../../utils/config';

type BuzzlUserFilterFormProps = {
  isSubmitting: boolean;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
  values: FilterData;
};

const BuzzlUserFiltersForm: React.FC<BuzzlUserFilterFormProps> = ({
  isSubmitting,
  setFieldValue,
  values,
}) => {
  return (
    <div className="px-4 divide-y divide-gray-200 sm:px-6">
      <fieldset className="space-y-6 pt-6 pb-5" disabled={isSubmitting}>
        <p className="text-base leading-6 font-semibold mb-2">Role</p>

        <FastField
          name="operator"
          onChange={() => {
            setFieldValue(
              'operator',
              values.operator === buzzlRoles.operator ? '' : buzzlRoles.operator
            );

            setFieldValue('admin', '');
          }}
          component={FormikCheckbox}
          label="Operator"
          checked={values.operator === buzzlRoles.operator}
        />

        <FastField
          name="admin"
          onChange={() => {
            setFieldValue(
              'admin',
              values.admin === buzzlRoles.admin ? '' : buzzlRoles.admin
            );
            setFieldValue('operator', '');
          }}
          component={FormikCheckbox}
          label="Admin"
          checked={values.admin === buzzlRoles.admin}
        />
      </fieldset>

      <fieldset className="space-y-6 pt-6 pb-5" disabled={isSubmitting}>
        <FastField
          type="text"
          name="customer"
          component={FormikInput}
          label="Customer"
          placeholder="Type Area name"
        />
      </fieldset>
    </div>
  );
};

export default BuzzlUserFiltersForm;
